const GATEWAY = process.env.VUE_APP_GATEWAY_ENDPOINT;
const API_ADMIN = process.env.VUE_APP_API_ADMIN_LOCATION;

export default {
  fetchAssessment(language) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`${GATEWAY}v3/assessments`, {
          headers: {
            'Accept-Language': language,
            ignoreLoading: true,
          },
        })
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(reject);
    });
  },
  create(body) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}assessments`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  update(id, body) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}assessments/${id}`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}assessments/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  createPage(body) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}assessments/page`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  updatePage(id, body) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}assessments/page/${id}`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  deletePage(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}assessments/page/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  createQuestion(body) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}assessments/question`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  updateQuestion(id, body) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}assessments/question/${id}`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  deleteQuestion(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}assessments/question/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
};
